/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import { gql } from "@apollo/client";

// This query is used to send T&C email copy
export const SENDTNCEMAIL = gql`
  query sendEmail($email: String!) {
    sendEmail(email: $email) {
      status
      message
    }
  }
`;

// This query is used to add user for consent agreement
export const ADDUSERTNCCONSENTAGREEMENT = gql`
  mutation addUserTncConsentAgreement($userId: String!, $status: Boolean!) {
    addUserTncConsentAgreement(userId: $userId, status: $status) {
      code
      message
    }
  }
`;

// // This query is used to get user for consent agreement
// export const GETUSERTNCCONSENTAGREEMENT = gql`
//   query getUserTncConsentAgreement($userId: String!) {
//     getUserTncConsentAgreement(userId: $userId) {
//       code
//       message
//       result {
//         userId
//         status
//       }
//     }
//   }
// `;

// This query is used to get user for consent agreement
export const GETUSERTNCCONSENTAGREEMENT = gql`
  query getDataByID($partyId: String!) {
  getDataByID(partyId: $partyId) { #"68123has"
    # aboNumber
    # accountId
    # accountName
    # accountSubType
    # country
    # language
    # partyId
    # recoUserId
    # salesPlanAff
    # status
    userConsent
    # userEmail
  }
}
`;
